var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.modelName,"actions":_vm.actions,"modelColumnDefs":_vm.modelColumnDefs,"showCreateBtn":false,"showDeleteBtn":false,"readOnly":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }